import type { IconGlyph } from '../icon';

/**
 * Tractie `timeline-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/timeline-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconTimelineThick: IconGlyph = {
  name: 'timeline-thick',
  path: 'M3.8 8h9.4c.99 0 1.8-.81 1.8-1.8V3.8c0-.99-.81-1.8-1.8-1.8H3.8C2.81 2 2 2.81 2 3.8v2.4C2 7.19 2.81 8 3.8 8M4 4h9v2H4zm6.21 12H3.79C2.8 16 2 16.8 2 17.79v2.43c0 .99.8 1.79 1.79 1.79h6.43c.99 0 1.79-.8 1.79-1.79v-2.43c0-.99-.8-1.79-1.79-1.79ZM10 20H4v-2h6zM20.5 9h-11C8.67 9 8 9.67 8 10.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5m-.5 4H10v-2h10z',
};
